export default "<p>dictionary works!</p>\n"